/** Nichos / verticais de e-commerce (tipo de loja), não plataforma tecnológica. */
export const ECOMMERCE_SEGMENTS = [
  'Moda e Vestuário',
  'Calçados',
  'Cosméticos e Beleza',
  'Perfumaria',
  'Acessórios e Joias',
  'Ótica',
  'Esportes e Fitness',
  'Suplementos',
  'Eletrônicos',
  'Informática e Games',
  'Casa e Decoração',
  'Móveis',
  'Cozinha e Utilidades',
  'Alimentos e Bebidas',
  'Vinhos e Bebidas Premium',
  'Saúde e Farmácia',
  'Pet Shop',
  'Infantil e Bebês',
  'Brinquedos',
  'Automotivo e Peças',
  'Ferramentas e Construção',
  'Papelaria e Escritório',
  'Livros e Cultura',
  'Artesanato',
  'Jardinagem',
  'Camping e Outdoor',
  'Instrumentos Musicais',
  'Relógios',
  'Sex Shop / Adulto',
  'Marketplace Multicategoria',
  'B2B / Atacado',
  'Moda Íntima',
  'Moda Praia',
  'Moda Fitness',
] as const

const CUSTOM_SEGMENTS_STORAGE_KEY = 'crm:custom-ecommerce-segments'

export function loadCustomEcommerceSegments(): string[] {
  if (typeof window === 'undefined') return []
  try {
    const raw = localStorage.getItem(CUSTOM_SEGMENTS_STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw) as unknown
    if (!Array.isArray(parsed)) return []
    return parsed.filter((item): item is string => typeof item === 'string' && item.trim().length > 0)
  } catch {
    return []
  }
}

export function saveCustomEcommerceSegments(segments: string[]): void {
  if (typeof window === 'undefined') return
  localStorage.setItem(CUSTOM_SEGMENTS_STORAGE_KEY, JSON.stringify(segments))
}

export function findEcommerceSegmentDuplicate(
  name: string,
  customSegments: string[] = loadCustomEcommerceSegments(),
): string | null {
  const trimmed = name.trim()
  if (!trimmed) return null
  const lower = trimmed.toLowerCase()
  const all = [...ECOMMERCE_SEGMENTS, ...customSegments]
  return all.find((segment) => segment.toLowerCase() === lower) ?? null
}

export function addCustomEcommerceSegment(
  name: string,
): { ok: true; segment: string } | { ok: false; error: string } {
  const trimmed = name.trim()
  if (!trimmed) return { ok: false, error: 'Informe o nicho do e-commerce' }

  const duplicate = findEcommerceSegmentDuplicate(trimmed)
  if (duplicate) {
    return { ok: false, error: `O nicho "${duplicate}" já existe na lista` }
  }

  const custom = loadCustomEcommerceSegments()
  custom.push(trimmed)
  saveCustomEcommerceSegments(custom)
  return { ok: true, segment: trimmed }
}

export function getEcommerceSegmentOptions(customSegments: string[] = loadCustomEcommerceSegments()): string[] {
  const listed = [...ECOMMERCE_SEGMENTS]
  const extra = customSegments.filter(
    (name) => !listed.some((item) => item.toLowerCase() === name.toLowerCase()),
  )
  return [...listed, ...extra]
}
